import XYInterface from '../custom/XYInterface.js';
import MultiXYInterface from '../custom/MultiXYInterface.js';
import {doc} from './docs.js';

doc(
    "interface.xy",
    {
    },
    "Interface for controlling 2 numbers using x/y plane",
    () => 0,
    {
        inlets: 0
    }
);
export const interface_xy = (object) => {
    let o = new XYInterface(object);
    object.width = 300;
    object.height = 300;
    return ([msg]) => {
    };
};

doc(
    "interface.multiXY",
    {
    },
    "Interface for controlling multiple pairs of 2 numbers using x/y plane",
    () => 0,
    {
        inlets: 0
    }
);
export const interface_multi_xy = (object) => {
    let o = new MultiXYInterface(object);
    object.width = 300;
    object.height = 300;
    return ([msg]) => {
    };
};

